import React from 'react';
import {Bar} from 'react-chartjs-2';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    ChartOptions,
    ChartData,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ChartDataLabels);

interface LineBarChartProps {
    data: number[];
}

const LABELS = ['виконано', 'виконується', 'не виконано', 'постійно'];
const COLORS = ['green', 'orange', 'red', 'gray'];

const LineBarChartComponent: React.FC<LineBarChartProps> = ({data}) => {
    const total = data.reduce((sum, val) => sum + val, 0);

    const chartData: ChartData<'bar', number[], string> = {
        labels: [''],
        datasets: data.map((value, index) => ({
            label: LABELS[index],
            data: [value],
            backgroundColor: COLORS[index],
            borderWidth: 0,
            barPercentage: 1.0,
            categoryPercentage: 1.0
        })),
    };

    const options: ChartOptions<'bar'> = {
        indexAxis: 'y',
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {display: false},
            tooltip: {
                enabled: false,
            },
            datalabels: {
                anchor: 'center',
                align: 'center',
                color: 'white',
                font: {
                    weight: 'bold',
                    size: 12,
                },
                formatter: (value: number) => value,
            },
        },
        scales: {
            x: {
                stacked: true,
                display: false,
                min: 0,
                max: total,
            },
            y: {
                stacked: true,
                display: false,
            },
        },
    };

    return (
        <div style={{width: '100%', minWidth: 0, height: '15px', overflow: 'hidden'}}>
            <Bar data={chartData} options={options} plugins={[ChartDataLabels]} />
        </div>
    );
};

export default LineBarChartComponent;
